<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p4-4/4-4.svg" />
    <div class="ctn-text animate-target" v-animate-in>Recommendations for nonsteroidal MRAs (finerenone) use are based on the highest grade of evidence (1A), similar to recommendation for existing agents established in practice (e.g. ACEi/ARB, SGLT-2i and antihypertensives therapy.<sup>1,2</sup></div>
    <GoNext class="animate-target" v-animate-in href="/section4/4-5">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";

export default {
  name: "s4-4",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"*For finerenone, CKD was defined as an eGFR of 25-60 mL/min/1.73 m<sup>2</sup>, UACR of 30-300 mg/g, and diabetic retinopathy, or an eGFR 25-75 mL/min/1.73 m<sup>2</sup> and UACR of 300-5000 mg/g in FIDELIO-DKD; an eGFR 25-90 mL/min/1.73 m<sup>2</sup> and UACR of 30 to <300 mg/g or an eGFR >60 mL/min/1.73 m<sup>2</sup> and UACR of 300-5000 mg/g in FIGARO-DKD; #for SGLT-2is, CKD was defined as an eGFR of 25-75 mL/min/1.73 m<sup>2</sup> and UACR of ≥200 5000 mg/g in DAPA-CKD; an eGFR of 20-45 mL/min/1.73 m<sup>2</sup> or an eGFR of 45-90 mL/min/1.73 m<sup>2</sup> with UACR of ≥200 mg/g in EMPA KIDNEY<br/><div class='brs'></div>"
      +"ACEi, angiotensin converting enzyme inhibitor; ARB, angiotensin receptor blocker; CKD, chronic kidney disease; CV, cardiovascular; ESC, European Society of Cardiology; HHF, hospitalisation for heart failure; MRA, mineralocorticoid receptor antagonist; SGLT-2i, sodium-glucose co-transporter-2 inhibitor; T2D, type 2 diabetes.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. Marx N <i>et al. J Hypertens</i> 2023; doi.org/10.1093/eurheartj/ehad19<br/>"
      +"2. McDonagh TA, <i>et al. Eur Heart J</i> 2023; doi:10.1093/eurheartj/ehad195/7246292",
      title:"ESC 2023 guideline recommendations for treatment of people with T2D and CKD<sup>1</sup>"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section4/s4.css";
.ctn-image {
  width: 100%;
  margin-top: 40px;
}
.ctn-text {
  margin-top: 40px;
}
</style>
